(function($) {
    'use strict';

    const $intros = $('.ce_rsce_intro'); 
    const $window = $(window);

    $intros.each(function(i, e) {
        var $intro = $(this);
        $intro.data('has-video', false);
        $intro.data('original-pos', $intro.offset().top);
        if ($intro.find('video').length > 0) {
            $intro.data('has-video', true);
        }
    });

    const animationCallback = function() {
        $intros.each(function() {
            let $intro = $(this);
            let originalPos = $intro.data('original-pos');
            let transform = ($window.scrollTop() - originalPos) * 0.5;
/*
            if (transform > 0) {
                $intro.css({
                    transform: 'translateY('+transform+'px)'
                });
            }
*/
            if (Utils.midVisible($intro)) {
                $intro.addClass('play');

                if ($intro.data('has-video') && !$intro.data('video-playing')) {
                    $intro.find('video').each(function() {
                        const $video = $(this);
                        $video.get(0).play();
                        $video.css('opacity', 1);
                    });
                    $intro.data('video-playing', true);
                }
            }
        });
        
        window.requestAnimationFrame(animationCallback);
    };

    if ($intros.length > 0) {
        window.requestAnimationFrame(animationCallback);
    }
})(jQuery);
